import "vite/modulepreload-polyfill";

import swup from "./swup";

import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect"; 

import { store as cart } from "@/stores/cart";  
import { store as popup } from "@/stores/popup";
import { store as productModal } from "@/stores/productModal";
import { store as consent } from "@/stores/consent";
import { store as sticky } from "@/stores/sticky";

import Carousel from "@/components/carousel";
import CartItem from "@/components/cart-item";
import Marquee from "@/components/marquee";
import ProductForm from "@/components/product-form";
import ProductCardForm from "@/components/product-card-form";
import SlideDot from "@/components/slide-dot";
import StickyCardScroll from "@/components/sticky-card-scroll";
import StickyScroll from "@/components/sticky-scroll";
import Newsletter from "@/components/newsletter";
import Video from "@/components/video";
import ProductWaitlist from "@/components/product-waitlist";
import Navigation from "@/components/navigation";
import giftWithPurchase from "@/components/gift-with-purchase";
import Upsell from "@/components/upsell";
import { money } from "@/utils";

/** Runs the same redirect as `product-variant-color-redirect` head script after Swup swaps `#main`. */
function applyProductVariantColorRedirect() {
  const el = document.getElementById("product-variant-color-redirect-data");
  if (!el) return;

  const params = new URLSearchParams(location.search);
  if (params.has("variant")) return;

  let targetId;
  try {
    targetId = JSON.parse(el.textContent);
  } catch {
    return;
  }
  if (targetId == null || targetId === "") return;

  params.set("variant", String(targetId));
  const qs = params.toString();
  const newUrl = `${location.pathname}${qs ? `?${qs}` : ""}${location.hash}`;
  location.replace(newUrl);
}

function loadStockistWidget() {
  const stockistWidget = document.querySelector("stockist-store-locator");
  if (!stockistWidget) return;
  const stockistScript = document.querySelector('script[src="https://stockist.co/embed/v1/widget.min.js"]');
  if (!stockistScript) return;

  const script = document.createElement("script");
  script.src = "https://stockist.co/embed/v1/widget.min.js";
  script.async = true;
  document.body.appendChild(script);
}

Alpine.directive("money", (el, { expression }, { evaluateLater, effect }) => {
  let setMoney = evaluateLater(expression);

  effect(() => {
    setMoney((price) => (el.innerHTML = money(price)));
  });
});

Alpine.plugin(intersect);
Alpine.plugin(focus);
Alpine.plugin(collapse); 

Alpine.store("consent", consent);
Alpine.store("cart", cart);  
Alpine.store("popup", popup);
Alpine.store("productModal", productModal);
Alpine.store("sticky", sticky);

Alpine.data("navigation", Navigation);
Alpine.data("slideDot", SlideDot);
Alpine.data("stickyScroll", StickyScroll);
Alpine.data("stickyCardScroll", StickyCardScroll);
Alpine.data("carousel", Carousel);
Alpine.data("marquee", Marquee);
Alpine.data("cartItem", CartItem);
Alpine.data("productForm", ProductForm);
Alpine.data("productCardForm", ProductCardForm);
Alpine.data("newsletter", Newsletter);
Alpine.data("productWaitlist", ProductWaitlist);
Alpine.data("upsell", Upsell);
Alpine.data("video", Video);

window.Alpine = Alpine;

swup.hooks.on("visit:start", (event) => {
  console.log("visit start: ", event);
});

swup.hooks.on("page:view", (event) => {
  console.log("page:view: ", event);

  applyProductVariantColorRedirect();
  loadStockistWidget();

  const videos = document.querySelectorAll("video");
  if (!videos) return;
  console.log("videos: ", videos);
  videos.forEach((video) => {
    video.load();
  });
});

applyProductVariantColorRedirect();
loadStockistWidget();

Alpine.start();
